require('./deferralSelector.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');

// @helpers
const { getFormattedString } = require('utilities/currencyHelper');
const { FormattedText } = require('core/i18n').i18n;

//@commons
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');

//@constants
const {
    MULTIPLE_QUOTA,
    ONE_QUOTA,
    THREE_QUOTA,
} = require('constants/lavanda');

class DeferralSelector extends React.Component {
    buildRadioButtons() {
        const { threeMonthQuotaAmount, tin, tae } = this.props;
        const options = [
            ONE_QUOTA,
            THREE_QUOTA,
            MULTIPLE_QUOTA
        ];
        const threeMonthQuotaText = !!threeMonthQuotaAmount ? getFormattedString(threeMonthQuotaAmount) : '';
        const labels = [
            <FormattedText key="1" value="lavanda-lavanda_deferralOption1" />,
            <FormattedText key="2" value="lavanda-lavanda_deferralOptionTwo" injectedStrings={[threeMonthQuotaText, tin, tae]}/>,
            <FormattedText key="3" value="lavanda-lavanda_deferralOptionThree" injectedStrings={[tin, tae]}/>,
        ];

        return options.map((option, index) => {
            return (
                <RadioButton
                    className="deferral-selector__container"
                    key={index}
                    label={labels[index]}
                    value={option}
                />
            );
        });
    }

    render() {
        const { onClick, selected } = this.props;

        return (
            <div className="deferral-selector">
                <RadioButtonGroup
                    name="situation-filter"
                    idPrefix="situation-filter-radio"
                    selectedValue={selected}
                    onChange={onClick}
                >
                    {this.buildRadioButtons()}
                </RadioButtonGroup>
            </div>
        );
    }
}

DeferralSelector.propTypes = {
    onClick: PropTypes.func.isRequired,
    selected: PropTypes.string,
    threeMonthQuotaAmount: PropTypes.object,
    tin: PropTypes.string.isRequired,
    tae: PropTypes.string.isRequired,
}

module.exports = DeferralSelector;